import { ProceedingSummary } from "./proceeding-summary.model";

export class ProceedingsSummary {
    constructor(
        public readonly proceedingsSummary: ProceedingSummary[],
        public readonly count: number,
    ) {}
}
